



import React from 'react'
import bannernew from "../images/banner.jpg";
import AmypepSyrup from "../images/Amypep Syrup 100ml NEW.jpg";
import KidCCD3ForteDrops from "../images/Kid CC-D3 Forte Drops photo.jpg"

function Slider() {
  return (
    <div>
      <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>

        </div>
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <img src={bannernew} className="d-block w-100" alt="Aristacure Biotech" />
            <div className="carousel-caption d-none d-md-block">

            </div>
          </div>
          
          <div className="carousel-item">
            <img src={AmypepSyrup} className="d-block w-100" alt="AmypepSyrup" />
            <div className="carousel-caption d-none d-md-block">

            </div>
          </div>
          <div className="carousel-item">
            <img src={KidCCD3ForteDrops} className="d-block w-100" alt="KidCCD3ForteDrops" />
            <div className="carousel-caption d-none d-md-block">

            </div>
          </div>

        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  )
}

export default Slider